// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { DASHBOARD_API_URL } from '../../../../constants/api/dashboard';


@Injectable()
export class DashBoardService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
    * dashboard common master api
    * @param payload : Api common payload object
    * @returns Observable<ApiResponse>
    */
  public dashboardCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${DASHBOARD_API_URL[payload.data.type]}`, replaceParams, payload);

    return this.post(url, payload.data.data);
  }

  /**
	 * Get Dashboards Data with give page no and size
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public getDashboardsPaging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      DASHBOARD_API_URL.GET_DASHBOARD_PAGING
      }`;

    return this.post(url, payload);
  }

  /**
	 * Get Dashboard Data for the given loopId
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public getDashboardById(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['dashboard_id'];
    // get url
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${DASHBOARD_API_URL.GET_DASHBOARD_ID}`,
      replaceParams,
      payload,
    );

    return this.get(url);
  }


  /**
 * Get Dashboard Data for the given loopId
 * @param payload : Api common payload object
 * @returns Observable<ApiResponse>
 */
  public getDashboardWidgetById(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['widget_id'];
    // get url
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${DASHBOARD_API_URL.GET_DASHBOARD_WIDGET_BY_ID}`,
      replaceParams,
      payload,
    );

    return this.get(url);
  }


  /**
	 * delete the loop
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public deleteDashboard(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['dashboard_id'];
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${DASHBOARD_API_URL.DELETE_DASHBOARD}`,
      replaceParams,
      payload,
    );

    return this.delete(url);
  }


  /**
 * create the Dashboard
 * @param payload : Api common payload object
 * @returns Observable<ApiResponse>
 */
  public createDashboard(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      DASHBOARD_API_URL.CREATE_DASHBOARD
      }`;

    return this.post(url, payload);
  }


  /**
   * Update the loop
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateDashboard(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      DASHBOARD_API_URL.UPDATE_DASHBOARD
      }`;

    return this.put(url, payload);
  }


  /**
   * create the Dashboard Widget
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public createDashboardWidget(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      DASHBOARD_API_URL.CREATE_DASHBOARD_WIDGET
      }`;

    return this.post(url, payload);
  }

  /**
   * Update the loop
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public updateDashboardWidget(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${
      DASHBOARD_API_URL.UPDATE_DASHBOARD_WIDGET
      }`;

    return this.put(url, payload);
  }


  /**
   * delete the loop
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public deleteDashboardWidget(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['widget_id'];
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${DASHBOARD_API_URL.DELETE_DASHBOARD_WIDGET}`,
      replaceParams,
      payload,
    );

    return this.delete(url);
  }

}

